const tabElementStyle = Object.freeze({
  removeMarginTop: false,
  listViewHeaderMiscStyles: null,
});

export default tabElementStyle;
